// @flow
import React from 'react';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import styles from "./styles.scss";

const AboutBanner = props => {
  const { height, isMobile } = useViewport();
  if (!props.data) {
    return null;
  }

  const {
    title,
    description,
    description_mobile,
    image,
    image_mobile,
    thumbnail,
    banner_video,
  } = props.data;
  let mobile_description = StringUtil.sliceHtml(description_mobile);
  let countLengthOf = StringUtil.sliceHtml(description);
  const length = words(countLengthOf).length;

  const renderDescription = () => {
    if (isMobile) {
      return <h3 className={'description-mobile'}>{mobile_description}</h3>;
    } else {
      return (
        <HTMLView
          className={'about-description'}
          html={description}
          tagName={'p'}
        />
      );
    }
  };

  const renderBannerTextMobile = () => {
    return (
      <div className={'banner-text'}>
        <h1>{title}</h1>
        {renderDescription()}
      </div>
    );
  };

  let className = 'about-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;
  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    bannerText = renderBannerTextMobile();
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'about-banner-image'}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
        length={length}
        description={renderDescription()}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && (
        <FooterExploreButton sectionName={'vision-and-philosophy'} />
      )}
    </div>
  );
};

export default AboutBanner;
